import React, { useEffect, useState } from 'react'
import injectStyles from 'react-jss'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

import InputLabel from '@material-ui/core/InputLabel'

import { styles } from './styles'

const PhoneStyled = ({
  label,
  classes,
  value,
  required = true,
  onChange,
  countries = [],
  onCountryChange,
  isTouched: isTouchedProps,
  additionalError = '',
  inputProps = {},
  cypress_id,
  country = 'us',
}) => {
  const [isTouched, setIsTouched] = useState(false)
  const [error, setError] = useState('')

  useEffect(() => {
    if (isTouchedProps) {
      setIsTouched(true)
    }
  }, [isTouchedProps])

  useEffect(() => {
    if (isTouched) {
      if (required && isTouched && !value.trim()) {
        setError('required')
      }
    }
  }, [isTouched])

  const onInputChange = (value, countryName, dialCode) => {
    let error = ''

    if (value.trim().length < 6) {
      error = 'Phone number is too short'
    }

    if (required && isTouched && !value.trim()) {
      error = 'required'
    }

    if ('+' + dialCode === value.trim()) {
      error = ''
    }

    if (onCountryChange && countries.length) {
      const selectCountry = countries.find(
        country => country.name === countryName,
      )
      if (selectCountry) {
        //onCountryChange(selectCountry.value)
      }
    }

    setError(error)
    onChange(value, error)
  }

  return (
    <div className={classes.wrap}>
      {label ? (
        <InputLabel className={classes.label}>
          <span>
            {label} {required ? <span style={{ color: 'red' }}>*</span> : null}
          </span>
        </InputLabel>
      ) : null}
      <PhoneInput
        country={country}
        value={value}
        specialLabel={null}
        onChange={(value, data) =>
          onInputChange('+' + value, data.name, data.dialCode)
        }
        required={required}
        disableCountryGuess={true}
        enableSearch
        inputProps={inputProps}
        cypress_id={cypress_id}
      />
      {error || additionalError ? (
        <div className={classes.error}>{error || additionalError}</div>
      ) : (
        <div className={classes.emptyMargin} />
      )}
    </div>
  )
}

export default injectStyles(styles)(PhoneStyled)
